/**
 * Feature flags configuration
 * Controls which features are enabled in different environments
 */

export interface FeatureFlags {
  bookingEngine: boolean;
  seasonalRoomTypes: boolean;
  groups: boolean;
  voiceAgent: boolean;
  chatVoice: boolean;
}

/**
 * Get feature flags from environment variables
 */
export const getFeatureFlags = (): FeatureFlags => {
  return {
    bookingEngine: process.env.REACT_APP_ENABLE_BOOKING_ENGINE === "true",
    seasonalRoomTypes:
      process.env.REACT_APP_ENABLE_SEASONAL_ROOM_TYPES === "true",
    groups: process.env.REACT_APP_ENABLE_GROUPS === "true",
    voiceAgent: process.env.REACT_APP_ONBOARDING_VOICE_AGENT === "true",
    chatVoice: process.env.REACT_APP_CHAT_VOICE_AGENT === "true",
  };
};

/**
 * Check if a specific feature is enabled
 */
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  const flags = getFeatureFlags();
  return flags[feature] || false;
};

/**
 * Export feature flags instance
 */
export const featureFlags = getFeatureFlags();
